export enum Civility {
  MISTER = 1,
  MADAM = 2,
  MISS = 3,
}

export enum CivilityLabel {
  MISTER = 'Monsieur',
  MADAM = 'Madame',
}
